import i18n from 'i18next';
import { RegisterOptions } from 'react-hook-form';

type HookFormRulesOptions = {
  required: boolean;
  startDateIsRequired: boolean;
  endDateIsRequired: boolean;
  min: number | string;
  max: number | string;
  maxLength: number;
  pattern: string;
};

export function requiredRule() {
  return {
    required: {
      value: true,
      message: i18n.t('GeneralFormBuilder.UiKit.Validation.Required'),
    },
  };
}

export const hookFormRules = (
  options: Partial<HookFormRulesOptions>,
): Omit<RegisterOptions, 'deps' | 'pattern' | 'valueAsNumber' | 'valueAsDate'> => {
  let result: RegisterOptions = {};

  if (options.required) {
    result = {
      ...result,
      ...requiredRule(),
    };
  }

  if (options.startDateIsRequired || options.endDateIsRequired) {
    result = {
      ...result,
      validate: (dateRange: [Date | null, Date | null] | null) => {
        if (options.startDateIsRequired && (!dateRange || !dateRange[0])) {
          return i18n.t('GeneralFormBuilder.UiKit.Validation.StartDateIsRequired');
        }

        if (options.endDateIsRequired && (!dateRange || !dateRange[1])) {
          return i18n.t('GeneralFormBuilder.UiKit.Validation.EndDateIsRequired');
        }

        return undefined;
      },
    };
  }

  if (options.required) {
    result = {
      ...result,
      required: {
        value: options.required,
        message: i18n.t('GeneralFormBuilder.UiKit.Validation.Required'),
      },
    };
  }

  if (options.maxLength) {
    result = {
      ...result,
      maxLength: {
        value: options.maxLength,
        message: i18n.t('GeneralFormBuilder.UiKit.Validation.MaxLength', {
          length: options.maxLength,
        }),
      },
    };
  }

  if (options.pattern) {
    result = {
      ...result,
      valueAsDate: false,
      valueAsNumber: false,
      pattern: {
        value: new RegExp(options.pattern),
        message: i18n.t('GeneralFormBuilder.UiKit.Validation.WrongPattern', {
          pattern: options.pattern,
        }),
      },
    };
  }

  if (options.max) {
    result = {
      ...result,
      max: {
        value: options.max,
        message: i18n.t('GeneralFormBuilder.UiKit.Validation.Max', {
          max: options.max,
        }),
      },
    };
  }

  if (options.min) {
    result = {
      ...result,
      min: {
        value: options.min,
        message: i18n.t('GeneralFormBuilder.UiKit.Validation.Min', {
          min: options.min,
        }),
      },
    };
  }

  return result;
};
